

export default () => {

    // Get host
    const hostname = window.location.hostname;

    const stagingTrackingId = "UA-209063896-2";
    const productionTrackingId = "UA-209063896-3";

    // Local? 
    if (hostname.includes('localhost')) {
        return stagingTrackingId;
    }

    // Staging? 
    else if (hostname.includes('staging')) {
        return stagingTrackingId;
    }

    // Production? 
    else {
        return productionTrackingId;
    }


}